import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function IntroSection() {
  return <>
      <div className="grid md:grid-cols-2 gap-12 mb-12 items-center" data-id="element-703">
        <div className="flex justify-center" data-id="element-704">
          <a href="https://www.bodor.com/us/" target="_blank" rel="noopener noreferrer" className="inline-block bg-white p-8 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-705">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS/Bodor%20Laser%20Logo.png800x800.png" alt="Bodor Laser Logo" className="block h-20 md:h-28 w-auto" data-id="element-706" />
          </a>
        </div>

        <div className="flex justify-center" data-id="element-707">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/2023/Tube-cutting%20fiber%20laser.png800x800.png" alt="Tube cutting fiber laser" className="block max-w-full h-auto object-contain max-h-72 drop-shadow-xl" data-id="element-708" />
        </div>
      </div>

      <div className="flex justify-center mb-20" data-id="element-709">
        <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Bodor%20Product%20Intro.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="flex items-center p-6 bg-[#002d4d] text-white rounded-xl hover:bg-[#003d66] transition-colors shadow-md group max-w-md w-full" data-id="element-710">
          <div className="bg-white/20 p-3 rounded-lg mr-4 group-hover:bg-[#f5693d] transition-colors" data-id="element-711">
            <FileTextIcon className="w-8 h-8" data-id="element-712" />
          </div>
          <div data-id="element-713">
            <h3 className="font-bold text-lg" data-id="element-714">Full Bodor Product Brochure</h3>
            <p className="text-white/80 text-sm" data-id="element-715">Click to Download</p>
          </div>
        </a>
      </div>
    </>;
}